import type { RouteConfig } from 'vue-router/types/router';

const routes: RouteConfig[] = [
    {
        path: '/admin',
        component: () => import(/* webpackChunkName: "admin" */ '@/components/EmptyWrapper.vue'),
        children: [
            {
                path: '',
                name: 'Admin',
                component: () => import(/* webpackChunkName: "admin" */ '@/views/AdminPanel/AdminPanel.vue'),
                meta: {
                    breadcrumb: [
                        {
                            name: 'Admin'
                        }
                    ]
                }
            },
            {
                path: 'users',
                name: 'Users',
                component: () => import(/* webpackChunkName: "admin" */ '@/views/AdminPanel/UsersView/UsersView.vue'),
                meta: {
                    breadcrumb: [
                        {
                            name: 'Admin',
                            link: '/admin'
                        },
                        {
                            name: 'Users',
                            link: '/admin/users'
                        }
                    ]
                }
            },
            {
                path: 'users/:username',
                name: 'User',
                component: () => import(/* webpackChunkName: "admin" */ '@/views/AdminPanel/UserView/UserView.vue'),
                meta: {
                    breadcrumb: [
                        {
                            name: 'Admin',
                            link: '/admin'
                        },
                        {
                            name: 'Users',
                            link: '/admin/users'
                        },
                        {
                            name: 'User'
                        }
                    ]
                }
            },
            {
                path: 'designs',
                name: 'Designs',
                component: () =>
                    import(/* webpackChunkName: "admin" */ '@/views/AdminPanel/MainDesignsView/MainDesignsView.vue'),
                meta: {
                    breadcrumb: [
                        {
                            name: 'Admin',
                            link: '/admin'
                        },
                        {
                            name: 'Designs'
                        }
                    ]
                }
            }
        ]
    },
    {
        path: '/pod',
        component: () => import(/* webpackChunkName: "admin" */ '@/components/EmptyWrapper.vue'),
        children: [
            {
                path: 'productBases',
                name: 'PodProductBases',
                component: () =>
                    import(
                        /* webpackChunkName: "admin" */ '@/views/AdminPanel/TemplateProductsView/TemplateProductsView.vue'
                    )
            }
        ]
    }
];

export default routes;
